exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".expansion-panel[data-v-e994b566]{max-height:300px;overflow-y:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-e994b566","scoped":true,"sourceMap":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/ShowCart.vue
// module id = 209
// module chunks = 11